import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { AuthService } from '../services/auth.service';
import { Observable, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AuthInterceptor implements HttpInterceptor {

    constructor(private authService: AuthService) {}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (this.isPublicEndpoint(req.url) || this.isPrimeFacesRequest(req.url) || this.isGoogle(req.url)) {
            return next.handle(req);
        }

        const token = this.authService.getToken();
        const authReq = token ? this.cloneWithToken(req, token) : req;

        return next.handle(authReq).pipe(
            catchError((error: HttpErrorResponse) => {
                if (error.status === 401) {
                    return this.authService.refreshAccessToken().pipe(
                        switchMap(newToken => next.handle(this.cloneWithToken(req, newToken)))
                    );
                }
                return throwError(() => error);
            })
        );
    }

    private isPublicEndpoint(url: string): boolean {
        return url.includes('/api/public/');
    }

    private isPrimeFacesRequest(url: string): boolean {
        return url.includes('https://www.primefaces.org/cdn/api/upload.php');
    }

    private isGoogle(url: string): boolean {
        return url.includes('maps.googleapis.com');
    }

    private cloneWithToken(req: HttpRequest<any>, token: string): HttpRequest<any> {
        return req.clone({ setHeaders: { Authorization: `Bearer ${token}` } });
    }
}
